import { useEffect, useRef } from 'react';
/**
 * Works like `useEffect` but only runs on component updates, not on mount.
 *
 * @param fn Callback function to be executed on component update
 * @param deps Dependencies to watch for changes
 */
export var useDidUpdate = function (fn, deps) {
    var mounted = useRef(false);
    useEffect(function () { return function () {
        mounted.current = false;
    }; }, []);
    useEffect(function () {
        if (mounted.current) {
            return fn();
        }
        mounted.current = true;
        return undefined;
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, deps);
};
//# sourceMappingURL=useDidUpdate.js.map